module.exports = __webpack_public_path__ + "e13ea747b5e106ae91cd7b503226b18c.svg";